import { SummerExtrasErrorEvent }  from '@/services/analytics/events';
import { AdobeBaseEvent }          from './adobe-base-event';
import { Store }                   from 'vuex';
import { AppState }                from '@/store';
import { ServicesContainer }       from '@/services';
import { AnalyticsEventType } from '../models';

export class AdobeSummerExtrasErrorEvent extends AdobeBaseEvent {
  name       = 'AdobeSummerExtrasErrorEvent';
  event = AnalyticsEventType.Error;
  eventType  = 'cmg_error';

  error!: {
    errors:       { value: number };
    errorName:    string;
    errorType:    string;
    errorMessage: string;
  };

  constructor(
    e: SummerExtrasErrorEvent,
    store: Store<AppState>,
    services: ServicesContainer
  ) {
    super(store, services);

    this.account.ranking = '(not-set)';
    
    this.web.webInteraction = {
      linkClicks: { value: 1 },
      name:       'try again',
      type:       'other',
    };

    this.web.webPageDetails = {
      language:   'en-us',
      name:       'rewards:extras:summer-of-extras',
      pageType:   'rewards',
      siteRegion: 'US',
      siteSection:'rewards',
    };

    this.error = {
      errors:      { value: 1 },
      errorName:   `rewardsStore|${e.errorMessage}`,
      errorType:   'rewardsStore',
      errorMessage:e.errorMessage,
    };
  }
}
